import PropTypes from "prop-types";
import { TextField, Box, InputAdornment, Icon } from "@mui/material";

function ParagraphField({ displayName, fieldRef, isOptional, options }) {
  // console.log(options);
  return (
    <Box>
      <TextField
        id={`dff_${fieldRef}`}
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        multiline
        minRows={4}
        // onBlur={(e) => {
        //   if (e.target.value === "") {
        //     return;
        //   }
        // }}
        options={options}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>keyboard</Icon>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
ParagraphField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

ParagraphField.defaultProps = {
  options: null,
};

export default ParagraphField;
